import React from "react";
import canopen from "../stack/canopen";

function hex(bytes) {
  if (!bytes) return "";
  return Array.from(bytes).map((b) => b.toString(16).toUpperCase().padStart(2, "0")).join(" ");
}

export default function NodesPage() {
  const [, setTick] = React.useState(0);
  
  React.useEffect(() => {
    const h = setInterval(() => setTick((n) => (n + 1) & 0xff), 1000);
    return () => clearInterval(h);
  }, []);

  // Listen for node name updates to refresh display
  React.useEffect(() => {
    const handleNameUpdate = () => setTick((n) => (n + 1) & 0xff);
    canopen.eventEmitter.on("node-name-updated", handleNameUpdate);
    return () => canopen.eventEmitter.removeListener("node-name-updated", handleNameUpdate);
  }, []);

  const nodes = React.useMemo(() => Array.from(canopen.nodes.values()).sort((a, b) => a.id - b.id), [/* tick */]);

  const onRename = async (nodeId, currentName) => {
    const next = window.prompt("Rename device", currentName || "");
    if (next == null) return;
    
    // Encode as UTF-8 bytes
    const enc = new TextEncoder();
    const bytes = enc.encode(next);
    
    try {
      // Use the new CANopen writeSDO API
      await canopen.writeSDO(nodeId, 0x1008, 0x00, bytes);
      
      // Update the node name locally
      const node = canopen.nodes.get(nodeId);
      if (node) {
        node.name = next;
        canopen.eventEmitter.emit("node-name-updated", { nodeId, name: next, node });
      }
    } catch (e) {
      alert("Rename failed: " + (e?.message || e));
    }
  };

  return (
    <section style={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
      <div style={{ padding: 12, borderBottom: "1px solid #e5e7eb" }}>
        <strong>CANopen Nodes</strong> — {nodes.length} known
      </div>
      <div style={{ flex: 1, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>Node</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>Name</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>PDO1</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>PDO2</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>PDO3</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>PDO4</th>
              <th style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #e5e7eb" }}>Last Seen</th>
            </tr>
          </thead>
          <tbody>
            {nodes.map((n) => (
              <tr key={n.id}>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0" }}>{n.id}</td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0" }}>
                  <span>{n.name || "—"}</span>
                  <button
                    onClick={() => onRename(n.id, n.name)}
                    title="Rename"
                    style={{ marginLeft: 8, border: "none", background: "transparent", cursor: "pointer" }}
                  >
                    ✏️
                  </button>
                </td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0", fontFamily: "monospace" }}>{hex(n.pdo1)}</td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0", fontFamily: "monospace" }}>{hex(n.pdo2)}</td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0", fontFamily: "monospace" }}>{hex(n.pdo3)}</td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0", fontFamily: "monospace" }}>{hex(n.pdo4)}</td>
                <td style={{ padding: 8, borderBottom: "1px solid #f0f0f0" }}>{n.lastSeen ? new Date(n.lastSeen).toLocaleTimeString() : "—"}</td>
              </tr>
            ))}
            {!nodes.length && (
              <tr>
                <td colSpan={7} style={{ padding: 12, opacity: 0.7 }}>No nodes yet. Connect and wait for PDO traffic.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
